"use strict";

var _toConsumableArray = require("/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime/helpers/toConsumableArray.js");
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.modifiers = void 0;
var react_1 = __importStar(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var styled_components_modifiers_1 = require("styled-components-modifiers");
var marked_1 = __importDefault(require("marked"));
var styled_components_1 = require("styled-components");
var Text_styled_1 = require("./Text.styled");
Object.defineProperty(exports, "modifiers", {
  enumerable: true,
  get: function get() {
    return Text_styled_1.modifiers;
  }
});
var atoms_utils_theme_1 = require("@lettucegrow/atoms.utils.theme");
var Text = function Text(_ref) {
  var id = _ref.id,
    className = _ref.className,
    content = _ref.content,
    children = _ref.children,
    modifiers = _ref.modifiers,
    as = _ref.as,
    isHTML = _ref.isHTML,
    size = _ref.size,
    onRef = _ref.onRef,
    dataNw = _ref.dataNw,
    onLinkClick = _ref.onLinkClick;
  var textRef = (0, react_1.useRef)();
  (0, react_1.useEffect)(function () {
    if (!isHTML) return;
    // parse <a> tags and handle linking in external callback
    var links = textRef.current ? textRef.current.querySelectorAll('a') : [];
    _toConsumableArray(links).forEach(function (linkNode) {
      linkNode.addEventListener('click', onLinkClick(linkNode.getAttribute('href'), linkNode.getAttribute('target'), linkNode.innerHTML));
      linkNode.removeAttribute('href');
    });
    return function () {
      _toConsumableArray(links).forEach(function (linkNode) {
        linkNode.removeEventListener('click', onLinkClick(linkNode.getAttribute('href'), linkNode.getAttribute('target'), linkNode.innerHTML));
      });
    };
  }, []);
  if (isHTML) {
    return react_1.default.createElement(styled_components_1.ThemeProvider, {
      theme: atoms_utils_theme_1.theme
    }, react_1.default.createElement(Text_styled_1.TextStyled, {
      id: id,
      className: className,
      modifiers: modifiers,
      as: 'div',
      dangerouslySetInnerHTML: {
        __html: (0, marked_1.default)(content)
      },
      size: size,
      ref: onRef || textRef,
      "data-nw": dataNw
    }));
  } else {
    return react_1.default.createElement(styled_components_1.ThemeProvider, {
      theme: atoms_utils_theme_1.theme
    }, react_1.default.createElement(Text_styled_1.TextStyled, {
      id: id,
      className: className,
      modifiers: modifiers,
      as: as,
      size: size,
      ref: onRef || textRef,
      "data-nw": dataNw
    }, content, children));
  }
};
Text.defaultProps = {
  id: '',
  content: '',
  modifiers: '',
  as: '',
  size: '',
  dataNw: null
};
Text.propTypes = {
  id: prop_types_1.default.string,
  className: prop_types_1.default.string,
  content: prop_types_1.default.oneOfType([prop_types_1.default.string, prop_types_1.default.object, prop_types_1.default.element, prop_types_1.default.number]),
  children: prop_types_1.default.any,
  modifiers: (0, styled_components_modifiers_1.styleModifierPropTypes)(Text_styled_1.modifiers),
  as: prop_types_1.default.string,
  size: prop_types_1.default.string,
  onRef: prop_types_1.default.func,
  dataNw: prop_types_1.default.string,
  onLinkClick: prop_types_1.default.func,
  isHTML: prop_types_1.default.bool
};
exports.default = Text;